import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  ICalendarState,
  setCalendarGridView,
  setExpandedView,
} from "@/app_redux/reducers/slices/auth/staff_calendar_slice";
import { setStaticSideBarStatus } from "@/app_redux/reducers/slices/ui_states_slice";
import { FiMinimize } from "react-icons/fi";
import { IoIosExpand } from "react-icons/io";
import { MdGridOff, MdGridOn } from "react-icons/md";
import { Tooltip } from "react-tooltip";

const CalendarViewToggleComponent = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("STAFF_CALENDAR", "id"));

  const dispatch = useAppDispatch();
  const { expandedView, gridView } = routeState.state as ICalendarState;

  const handleExpandedView = () => {
    if (expandedView) {
      dispatch(setExpandedView(false));
      dispatch(setStaticSideBarStatus({ status: false }));
      return;
    }
    dispatch(setExpandedView(true));
    dispatch(setStaticSideBarStatus({ status: false }));
  };

  // useEffect(() => {
  //   if (routeState && !initialExpand) {
  //     dispatch(setExpandedView(true));
  //     dispatch(setStaticSideBarStatusMobile({ status: true }));
  //     seInitialExpand(true);
  //   }
  // }, [routeState, initialExpand]);

  return (
    <div className="flex justify-start items-center gap-x-4">
      <button
        data-tooltip-id="calendar-filter-buttons"
        data-tooltip-content={gridView ? "Calendar View" : "Staff Grid View"}
        onClick={() => {
          dispatch(setCalendarGridView(!gridView));
        }}
        className="p-2 rounded-md bg-gray-100 hover:bg-blue-100 hover:text-blue-500 text-xl"
      >
        {gridView ? <MdGridOff /> : <MdGridOn />}
      </button>
      <button
        data-tooltip-id="calendar-filter-buttons"
        data-tooltip-content={expandedView ? "Shrink Calendar View" : "Expand Calendar View"}
        onClick={handleExpandedView}
        className="p-2 rounded-md bg-gray-100 hover:bg-blue-100 hover:text-blue-500 text-xl"
      >
        {expandedView ? <FiMinimize /> : <IoIosExpand />}
      </button>
      <Tooltip id="calendar-filter-buttons" style={{ fontSize: "10px" }} />
    </div>
  );
};

export default CalendarViewToggleComponent;
